export enum QuestionTypes {
  likert = 'likert',
  multipleChoice = 'multiple-choice',
  multipleOptions = 'multiple-options',
  dateTimeMultiple = 'date_time_multiple',
  fill = 'fill',
  fillMultiple = 'fill-multiple',
  fillWithFormat = 'fill-with-format',
  fillMultipleWithFormat = 'fill-multiple-with-format',
  fillMultipleWithFormatFixed = 'fill-multiple-with-format-fixed',
  fillMultipleWithFormatFixedLabel = 'fill-multiple-with-format-fixed-label',
  fillMultipleBreakoutWithFormat = 'fill-multiple-breakout-with-format',
  yesNo = 'yes-no',
}
